<i18n>
{
  "en": {
    "addInitialRecommendation": "Add default initial recommendations",
    "allergens": "Allergens",
    "bannerImageHint": "Banner image to show in the menu footer. Optional",
    "bannerRecommendationsOptions": "Banner recommendation settings",
    "branding": "Branding",
    "brandingImageHintExisting": "Branding image to show in menu footer. Warning, the current one will be overridden!",
    "cartOptions": "Edit shopping cart",
    "createCustomInitialRecommendation": "Create custom initial recommendations",
    "customInitialRecommendationText": "Custom initial recommendations",
    "defaultInitialRecommendationText": "Default initial recommendations",
    "defaultRecommendationText": "We recommend it with these products",
    "displayBranding": "Display branding block",
    "displayIconPopup": "Show popup icon",
    "displayProductDescription": "Show product description",
    "displayProductTags": "Display product tags",
    "displayProductTagsUsingIcons": "Display product tags using icons",
    "displaySocialMedia": "Display social media",
    "displaySocialMediaIcons": "Display social media icons",
    "displayShoppingCart": "Display shopping cart",
    "emptyFieldError": "Mandatory field",
    "fileSizeError": "Image is too big. Maximum size is 2 MB.",
    "footerText": "Footer text",
    "getMenuConfigurationError": "There a re problem retriving the menu configuration",
    "image": "Select image from file",
    "initialRecommendationText": "Initial recommendation settings",
    "initialRecommendationTitle": "Initial recommendation name",
    "initialRecommendations": "Enable initial recommendation",
    "initialRecommendationsOptions": "Initial recommendation settings",
    "modalTitle": "Settings",
    "notInitialRecommendationTitleText": "There are not default initial recommendations created",
    "previousFile": "Previous File",
    "product": "Product block",
    "productRecommendations": "Enable product recommendations",
    "productRecommendationsOptions": "Product recommendation settings",
    "recommendations": "Recommendations",
    "recommendationDefaultName": "Recommendation",
    "recommendationText": "Recommendation Text by default",
    "setDefaultFeaturesStatus": "Show allergens by default on the menu",
    "styles": "Use of styles",
    "textError": "Mandatory field, 128 characters max",
    "useAllergensAsText": "Display menu allergens as icon",
    "useBannerRecommendationSelector": "Use banner recommendation",
    "useButtons": "Use button styling",
    "useCurrency": "Use currencies next to prices",
    "useFlagsMenuLanguageSelector": "Menu language selector uses flag images",
    "useHyphenText": "Use hyphen in product titles",
    "useMenuBorder": "Use border in the menu",
    "usePricesToRight": "Justify prices to the right",
    "useProductSeparator": "Use product separator",
    "useShoppingCart": "Option that handles if the ticket breakdown will be shown in the menu",
    "useSubsectionBorders": "Use borders in subsection headings",
    "useTextOutline": "Use text outline",
    "shopText": "Banner text of cart menu",
    "shopTextProductPopupQty": "Text of the product popup, where the quantity refers",
    "shopTextProductPopupComment": "Text of the product popup, where the comment title refers",
    "shopTextProductPopupSpecialTextComment": "Text of the product popup, where the message below the comment refers",
    "shopTextProductPopupAddBtn": "Product popup text, add button",
    "shopCartTextTotal": "Cart popup text, Total text",
    "shopCartTextOrderBtn": "Order button text in cart popup",
    "shopCartTextCommentBtnSave": "Cart button text to save the comment",
    "shopCartTitleModal": "Title top of cart modal",
    "shopCartSuccessMessageOrder": "Shop cart success order message",
    "shopCartErrorMessageOrder": "Shop cart error order message"
  },
  "es": {
    "addInitialRecommendation": "Añadir recomendaciones iniciales por defecto",
    "allergens": "Alérgenos",
    "bannerImageHint": "Imagen de banner para mostrar en el pie de página del menú (Opcional)",
    "bannerRecommendationsOptions": "Personalización de las recomendaciones del banner",
    "branding": "Branding",
    "brandingImageHintExisting": "Imagen de branding para mostrar en el pie de página del menú (la actual será remplazada)",
    "cartOptions": "Personalización del carrito de la compra",
    "createCustomInitialRecommendation": "Crear más recomendaciones",
    "customInitialRecommendationText": "Recomendaciones iniciales personalizadas",
    "defaultInitialRecommendationText": "Recomendaciones iniciales por defecto",
    "defaultRecommendationText": "Te lo recomendamos con estos productos",
    "displayBranding": "Mostrar el bloque de branding",
    "displayIconPopup": "Mostrar el icono del popup",
    "displayProductDescription": "Mostrar descripción de los productos",
    "displayProductTags": "Mostrar etiquetas de los productos",
    "displayProductTagsUsingIcons": "Mostrar etiquetas de los productos usando iconos",
    "displaySocialMedia": "Mostrar redes sociales",
    "displaySocialMediaIcons": "Mostrar iconos de redes sociales",
    "emptyFieldError": "Campo obligatorio",
    "fileSizeError": "La imagen es demasiado grande. El tamaño máximo es 2 MB.",
    "footerText": "Texto en el pie del menú",
    "getMenuConfigurationError": "Hubo un error al obtener los ajustes del menú",
    "image": "Selecciona la imagen desde el explorador",
    "initialRecommendationText": "Texto de recomendación inicial ({0}) a mostrar",
    "initialRecommendationTitle": "Nombre de la recomendación inicial",
    "initialRecommendations": "Activar la recomendación inicial",
    "initialRecommendationsOptions": "Personalización de la recomendación inicial",
    "modalTitle": "Ajustes",
    "notInitialRecommendationTitleText": "No hay recomendaciones creadas por defecto",
    "previousFile": "Archivo anterior",
    "product": "Bloque de producto",
    "productRecommendations": "Activar recomendaciones de productos",
    "productRecommendationsOptions": "Personalización de las recomendaciones",
    "recommendations": "Recomendaciones",
    "recommendationDefaultName": "Recomendación",
    "recommendationText": "Texto de recomendación por defecto",
    "setDefaultFeaturesStatus": "Mostrar alérgenos por defecto en la carta",
    "styles": "Uso de estilos",
    "textError": "Campo obligatorio, máximo 512 caracteres",
    "useAllergensAsText": "Mostrar los alérgenos del menú como icono",
    "useBannerRecommendationSelector": "Usar la recomendaciones del banner",
    "useButtons": "Utilizar estilo de botones",
    "useCurrency": "Utilizar divisas junto a los precios",
    "useFlagsMenuLanguageSelector": "El selector de idioma del menú utiliza imágenes de banderas",
    "useHyphenText": "Usar guion en el título de los productos",
    "useMenuBorder": "Utilizar borde en el menú",
    "usePricesToRight": "Justificar precios a la derecha",
    "useProductSeparator": "Utilizar separador de productos",
    "useShoppingCart": "Opción para indicar si se va a mostrar el desglose del ticket en el menú",
    "useSubsectionBorders": "Utilizar bordes en los títulos de las subsecciones",
    "useTextOutline": "Utilizar bordeado en el texto",
    "shopText": "Texto del banner del carrito del menu",
    "shopTextProductPopupQty": "Texto del popup de producto, donde hace referencia la cantidad",
    "shopTextProductPopupComment": "Texto del popup del producto, donde hace referencia el titulo del comentario",
    "shopTextProductPopupSpecialTextComment": "Texto del popup del producto, donde hace referencia el mensaje debajo del comentario",
    "shopTextProductPopupAddBtn": "Texto del popup del producto, boton de agregar",
    "shopCartTextTotal": "Texto del popup del carrito, texto del Total",
    "shopCartTextOrderBtn": "Texto del boton de la orden en el popup del carrito",
    "shopCartTextCommentBtnSave": "Texto del boton de carrito para guardar el comentario",
    "shopCartTitleModal":  "Titulo superior del modal del carrito",
    "shopCartSuccessMessageOrder": "Mensaje de exito de la orden del carrito",
    "shopCartErrorMessageOrder": "Mensaje de error de la orden del carrito"
  }
}
</i18n>

<template>
  <v-dialog @click:outside="onCancel" v-model="visible" max-width="600px" persistent>
    <div v-if=visible class="px-7 py-5">
      <v-card-title class="pa-0">
        {{ $t('modalTitle') }}
      </v-card-title>
      <div style="background-color: #ffffff">
        <v-form v-model="valid" ref="form">
          <v-tabs v-model="tab" class="my-tabs" background-color="transparent" show-arrows>
            <v-tab
              v-if="showUseButtons
              ||showBordersInMenu
              ||showBorderSubsectionsHeading
              ||showTextOutline
              ||showUseFlagsOption
              ||showProductSeparator"
            >
              {{ $t('styles') }}
            </v-tab>
            <v-tab>{{ $t('product') }}</v-tab>
            <v-tab v-if="showAllergensByDefault">{{ $t('allergens') }}</v-tab>
            <v-tab v-if="showBrandingOption">{{ $t('branding') }}</v-tab>
            <v-tab
              v-if="showUseProductRecommendations||showUseInitialRecommendation"
            >
              {{ $t('recommendations') }}
            </v-tab>
            <v-tab v-if="showUseShoppingCart">{{ $t('shoppingCart') }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" data-testid="tab-input">
            <!-- Styles options -->
            <v-tab-item
              v-if="showUseButtons
              ||showBordersInMenu
              ||showBorderSubsectionsHeading
              ||showTextOutline
              ||showUseFlagsOption
              ||showProductSeparator"
              class="mt-5"
            >
              <v-switch v-if="showUseButtons" v-model="useButtons" :label="$t('useButtons')"/>
              <v-switch
                v-if="showBordersInMenu"
                v-model="menuConfiguration.setBorderToMenu"
                :label="$t('useMenuBorder')"
              />
              <v-switch
                v-if="showBorderSubsectionsHeading"
                v-model="menuConfiguration.setBordersToSubsections"
                :label="$t('useSubsectionBorders')"
              />
              <v-switch
                v-if="showProductSeparator"
                v-model="menuConfiguration.useSeparatorOfProduct"
                :label="$t('useProductSeparator')"
              />
              <v-switch
                v-if="showTextOutline"
                v-model="menuConfiguration.useTextOutline"
                :label="$t('useTextOutline')"
              />
              <!-- Uso de banderas -->
              <v-switch
                v-if="showUseFlagsOption"
                v-model="menuConfiguration.useFlagsMenuLanguageSelector"
                :label="$t('useFlagsMenuLanguageSelector')"
              />
            </v-tab-item>
            <!-- Product options -->
            <v-tab-item class="mt-5">
              <v-switch
                v-if="showPriceSettings"
                v-model="menuConfiguration.displayCurrency"
                :label="$t('useCurrency')"
              />
              <v-switch
                v-if="showPriceSettings"
                v-model="menuConfiguration.setPricesJustifiedToRight"
                :label="$t('usePricesToRight')"
              />
              <!-- Product options for grid template -->
              <v-divider v-if="showUseHyphenText" class="mb-3"/>
              <v-switch
                v-if="showUseHyphenText"
                v-model="menuConfiguration.useHyphenText"
                :label="$t('useHyphenText')"
              />
              <v-switch
                v-if="showDisplayIconPopup"
                v-model="menuConfiguration.displayIconPopup"
                :label="$t('displayIconPopup')"
              />
              <v-switch
                v-if="showDisplayProductDescription"
                v-model="menuConfiguration.displayProductDescription"
                :label="$t('displayProductDescription')"
              />
              <!-- Product tag options -->
              <v-divider v-if="showProductTagOption" class="mb-3"/>
              <v-switch
                v-if="showProductTagOption"
                v-model="menuConfiguration.displayProductTags"
                :label="$t('displayProductTags')"
              />
              <v-switch
                v-if="showProductTagOption"
                v-model="menuConfiguration.displayProductTagsUsingIcons"
                :label="$t('displayProductTagsUsingIcons')"
              />
            </v-tab-item>
            <!-- Allergen options -->
            <v-tab-item v-if="showAllergensByDefault" class="mt-5">
              <v-switch
                v-if="showAllergensByDefault"
                v-model="menuConfiguration.defaultAllergensStatus"
                :label="$t('setDefaultFeaturesStatus')"
              />
              <v-switch
                v-if="showAllergensAsTextOption"
                v-model="menuConfiguration.useIconInProductFeatures"
                :label="$t('useAllergensAsText')"
              />
            </v-tab-item>
            <!-- Branding options -->
            <v-tab-item v-if="showBrandingOption" class="mt-5">
              <v-switch
                v-if="showBrandingOption"
                v-model="menuConfiguration.displayBranding"
                :label="$t('displayBranding')"
              />
              <v-switch
                v-if="showBrandingOption"
                v-model="menuConfiguration.displaySocialMedia"
                :label="$t('displaySocialMedia')"
              />
              <v-switch
                v-if="showBrandingOption"
                v-model="menuConfiguration.displaySocialMediaIcons"
                :label="$t('displaySocialMediaIcons')"
              />
              <div v-if="showBrandingOption">
                <dynameat-language-field-generator
                  v-model="footerText"
                  :label="$t('footerText')"
                  :type="'textArea'"
                  :rules="textRules"
                  required
                />
              </div>
              <v-file-input
                v-if="showBrandingOption"
                v-model="brandingImage"
                :rules="imageRules"
                :show-size="showBrandingImageSize"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera" persistent-hint
                :hint="bannerImageHint"
                :label="$t('image')"
                class="mb-6"
              />
            </v-tab-item>
            <!-- Recommendations options -->
            <v-tab-item
              v-if="showUseProductRecommendations||showUseInitialRecommendation"
              class="mt-5"
            >
              <div v-if="showUseProductRecommendations">
                <div class="mb-2">{{ $t('productRecommendationsOptions') }}</div>
                <v-switch
                  v-model="useProductRecommendations"
                  :label="$t('productRecommendations')"
                />
                <div v-if="showProductRecommendationOptions">
                  <dynameat-language-field-generator
                    v-model="recommendationText"
                    :label="$t('recommendationText')"
                    :type="'textArea'"
                    :rules="textRules" required/>
                </div>
              </div>
              <div v-if="showUseInitialRecommendation">
                <v-divider class="mb-3"/>
                <div class="mb-2">{{ $t('initialRecommendationsOptions') }}</div>
                <v-switch
                  v-model="useInitialRecommendations"
                  :label="$t('initialRecommendations')"
                />
                <div v-if="showInitialRecommendationOptions">
                  <div class="text-subtitle-1 mb-2">{{
                      $t('defaultInitialRecommendationText')
                    }}
                  </div>
                  <p
                    v-if="localInitialRecommendations.length === 0" class="text-center font-italic">
                    {{ $t('notInitialRecommendationTitleText') }}
                  </p>
                  <div v-for="(initialRecommendation, index) in localInitialRecommendations"
                       :key="initialRecommendation.guid">
                    <menu-initial-recommendation-settings
                      :initialRecommendationProp="initialRecommendation"
                      :onDelete="onDeleteDefaultRecommendation"
                      :defaultRecommendationTitle="nextDefaultRecommendationTitle"
                      @onChange="(value) => handleInitialRecommendation(value, index)"
                    />
                  </div>
                  <div class="d-flex flex-row justify-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="ma-0 pa-0 align-self-top"
                          v-on="on"
                          v-bind="attrs"
                          @click="onCreateDefaultRecommendation"
                          :disabled="isDisabledCreateDefaultRecommendation"
                        >
                          <v-icon color="grey" x-large>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('addInitialRecommendation') }}</span>
                    </v-tooltip>
                  </div>
                  <v-divider class="mt-2 mb-0"/>
                  <div class="text-subtitle-1 mt-4 mb-2">{{
                      $t('customInitialRecommendationText')
                    }}
                  </div>
                  <div class="d-flex flex-row justify-center">
                    <v-btn class="mb-2" small @click="onEditInitialRecommendation">
                      {{ $t('createCustomInitialRecommendation') }}
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-divider class="mb-3"/>
              <div class="mb-2">{{ $t('bannerRecommendationsOptions') }}</div>
              <v-switch
                v-if="showUseBannerRecommendation"
                v-model="menuConfiguration.useBannerRecommendation"
                :label="$t('useBannerRecommendationSelector')"
              />
            </v-tab-item>
            <!-- Shopping cart options -->
            <v-tab-item v-if="showUseShoppingCart" class="mt-5">
              <div v-if="showUseShoppingCart">
                <v-divider class="mb-3"/>
                <div class="mb-2">{{ $t('cartOptions') }}</div>
                <dynameat-language-field-generator
                    v-model="shopText" :label="$t('shopText')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopTextProductPopupQty" :label="$t('shopTextProductPopupQty')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopTextProductPopupComment" :label="$t('shopTextProductPopupComment')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopTextProductPopupSpecialTextComment" :label="$t('shopTextProductPopupSpecialTextComment')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopTextProductPopupAddBtn" :label="$t('shopTextProductPopupAddBtn')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopCartTextTotal" :label="$t('shopCartTextTotal')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopCartTextOrderBtn" :label="$t('shopCartTextOrderBtn')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopCartTextCommentBtnSave" :label="$t('shopCartTextCommentBtnSave')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopCartTitleModal" :label="$t('shopCartTitleModal')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopCartSuccessMessageOrder" :label="$t('shopCartSuccessMessageOrder')"
                    :rules="CartRules" required :type="'textField'"/>
                <dynameat-language-field-generator
                    v-model="shopCartErrorMessageOrder" :label="$t('shopCartErrorMessageOrder')"
                    :rules="CartRules" required :type="'textField'"/>
              </div>
            </v-tab-item>
          </v-tabs-items>

        </v-form>
        <dynameat-modal-buttons
          @cancel="onCancel"
          @confirm="onConfirm"
          :confirmDisabled="!valid"
          :confirmText="$t('confirm')"
          class="mt-4"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {
  imageFileType,
  maxChars, maxSize, notEmptyObject
} from '@core/helpers/formValidators';
import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import DynameatAutocomplete from '@dynameat/components/DynameatAutocomplete';
import cloneDeep from 'lodash/cloneDeep';
import { MenuInitialRecommendation } from '@manualConfig/views/menuInitialRecommendation/models';
import DynameatLanguageFieldGenerator from '@dynameat/components/DynameatLanguageFieldGenerator';
import { productTextFilter } from '@core/mixins';
import FontCreateModal from './FontCreateModal.vue';
import { MenuConfiguration } from '../models';
import MenuInitialRecommendationSettings from './MenuInitialRecommendationSettings.vue';

@Component({
  components: { MenuInitialRecommendationSettings }
})
@Components({
  DynameatModalButtons,
  DynameatConfirmationModal,
  FontCreateModal,
  DynameatAutocomplete,
  DynameatLanguageFieldGenerator,
  MenuInitialRecommendationSettings
})
@MapGetters(['templateList', 'editableProductList', 'serviceList', 'pointOfSaleLanguages'])
@MapActions(['addNotification', 'deleteMenuFontRequest', 'menuConfigurationRequest'])
export default class MenuSettingsModal extends Vue {
  @Prop({ String, default: 'templateGuid ' }) templateGuid;

  @Prop({ Boolean, default: false }) visible;

  @Prop({ Array, default: () => [] }) initialRecommendations;

  @Prop({ String, default: 'menuGuid' }) menuGuid;

  @Prop({ String, default: 'menuConfigurationGuid' }) menuConfigurationGuid;

  menuConfiguration = MenuConfiguration.toInstance();

  valid = false;

  useButtons = false;

  useShoppingCart = false;

  recommendationText = {};

  useProductRecommendations = false;

  useInitialRecommendations = false;

  localInitialRecommendations = [];

  deletedInitialRecommendations = [];

  selectedInitialRecommendation = null;

  useBannerRecommendation = false;

  tab = 0;

  footerText = {};

  brandingImage = null;

  shopText = {};

  shopTextProductPopupQty = {};

  shopTextProductPopupComment = {};

  shopTextProductPopupSpecialTextComment = {};

  shopTextProductPopupAddBtn = {};

  shopCartTextTotal = {};

  shopCartTextOrderBtn = {};

  shopCartTextCommentBtnSave = {};

  shopCartTitleModal = {}

  shopCartSuccessMessageOrder = {}

  shopCartErrorMessageOrder = {}

  productTextFilter = productTextFilter;

  get objectRules() {
    return [notEmptyObject(this.$t('emptyFieldError'))];
  }

  get availableLanguages() {
    return this.pointOfSaleLanguages;
  }

  get textRules() {
    return {
      alt1: [maxChars(this.$t('textError'), 512)],
      alt2: [maxChars(this.$t('textError'), 512)],
      alt3: [maxChars(this.$t('textError'), 512)]
    };
  }

  get CartRules() {
    return {
      alt1: [maxChars(this.$t('textError'), 128)],
      alt2: [maxChars(this.$t('textError'), 128)],
      alt3: [maxChars(this.$t('textError'), 128)]
    };
  }

  get currentTemplate() {
    return this.templateList.find((el) => el.guid === this.templateGuid);
  }

  get showUseButtons() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_BUTTONS');
  }

  get showUseShoppingCart() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_SHOPPING_CART');
  }

  get showUseProductRecommendations() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_PRODUCT_RECOMMENDATIONS');
  }

  get showUseInitialRecommendation() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_INITIAL_RECOMMENDATIONS');
  }

  get showBordersInMenu() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_BORDERS_IN_MENU');
  }

  get showBorderSubsectionsHeading() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_BORDER_SUBSECTIONS_HEADING');
  }

  get showAllergensByDefault() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_ALLERGENS_BY_DEFAULT');
  }

  get showTextOutline() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_TEXT_OUTLINE');
  }

  get showUseHyphenText() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_HYPHEN_TEXT');
  }

  get showDisplayIconPopup() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_ICON_POPUP');
  }

  get showDisplayProductDescription() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_PRODUCT_DESCRIPTION');
  }

  get showPriceSettings() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_PRICE_SETTINGS');
  }

  get showAllergensAsTextOption() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_ALLERGENS_AS_TEXT');
  }

  get showBrandingOption() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_BRANDING');
  }

  get showProductTagOption() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_PRODUCT_TAG');
  }

  get showProductSeparator() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_PRODUCT_SEPARATOR');
  }

  get showUseFlagsOption() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'SHOW_FLAGS');
  }

  get showUseBannerRecommendation() {
    return !this.currentTemplate?.isOperationDisallowed('MENU_CONFIGURATION', 'USE_BANNER_RECOMMENDATION');
  }

  get showProductRecommendationOptions() {
    return this.useProductRecommendations;
  }

  get showInitialRecommendationOptions() {
    return this.useInitialRecommendations;
  }

  get defaultProductImg() {
    // eslint-disable-next-line global-require
    return require('@dynameat/assets/images/dynameat-logo-secondary.png');
  }

  get isDisabledCreateDefaultRecommendation() {
    // Check if exist default recommendation
    const defaultInitial = this.localInitialRecommendations.find((initialRecommendation) => initialRecommendation.activeByDefault);

    // if form is not valid, we do not allow to create a new recommendation
    const formDisabled = !this.valid;
    return defaultInitial || formDisabled;
  }

  get nextDefaultRecommendationTitle() {
    const name = this.$t('recommendationDefaultName');
    const recommendations = this.initialRecommendations;
    let i = 0;
    let defaultTitle = '';
    do {
      i += 1;
      defaultTitle = name.concat(' ', i);
    } while (recommendations.some((recommendation) => recommendation.title === defaultTitle));
    return defaultTitle;
  }

  get imageRules() {
    return [maxSize(this.$t('fileSizeError'), 2000000), imageFileType(this.$t('fileFormatError'))];
  }

  get showBrandingImageSize() {
    return this.brandingImage instanceof File && this.brandingImage.size > 0;
  }

  get bannerImageHint() {
    if (this.brandingImage) {
      return this.$t('brandingImageHintExisting');
    }
    return this.$t('bannerImageHint');
  }

  @Watch('menuConfiguration')
  onMenuConfigurationChange(updatedMenuConfiguration) {
    if (updatedMenuConfiguration) {
      this.useButtons = updatedMenuConfiguration.useButtons;
      this.useShoppingCart = updatedMenuConfiguration.useShoppingCart;
      this.availableLanguages.forEach((language) => {
        this.recommendationText[language.alternative] = updatedMenuConfiguration[`recommendationText${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || this.$t('defaultRecommendationText', language.alternative);
      });
      this.useProductRecommendations = updatedMenuConfiguration.useProductRecommendations;
      this.useInitialRecommendations = updatedMenuConfiguration.useInitialRecommendations;
      this.availableLanguages.forEach((language) => {
        this.footerText[language.alternative] = updatedMenuConfiguration[`footerText${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopText[language.alternative] = updatedMenuConfiguration[`shopText${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopTextProductPopupQty[language.alternative] = updatedMenuConfiguration[`shopTextProductPopupQty${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopTextProductPopupComment[language.alternative] = updatedMenuConfiguration[`shopTextProductPopupComment${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopTextProductPopupSpecialTextComment[language.alternative] = updatedMenuConfiguration[`shopTextProductPopupSpecialTextComment${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopTextProductPopupAddBtn[language.alternative] = updatedMenuConfiguration[`shopTextProductPopupAddBtn${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopCartTextTotal[language.alternative] = updatedMenuConfiguration[`shopCartTextTotal${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopCartTextOrderBtn[language.alternative] = updatedMenuConfiguration[`shopCartTextOrderBtn${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopCartTextCommentBtnSave[language.alternative] = updatedMenuConfiguration[`shopCartTextCommentBtnSave${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopCartTitleModal[language.alternative] = updatedMenuConfiguration[`shopCartTitleModal${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopCartSuccessMessageOrder[language.alternative] = updatedMenuConfiguration[`shopCartSuccessMessageOrder${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
        this.shopCartErrorMessageOrder[language.alternative] = updatedMenuConfiguration[`shopCartErrorMessageOrder${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] || '';
      });
      this.brandingImage = updatedMenuConfiguration.branding_image ? new File([], this.$t('previousFile')) : null;
    }
  }

  @Watch('visible')
  onUpdatedVisible(newVisible) {
    if (newVisible) {
      this.getMenuConfiguration();
      this.getMenuInitialRecommendation();
      this.deletedInitialRecommendations = [];
    }
  }

  handleInitialRecommendation(initialRecommendation, index) {
    this.localInitialRecommendations[index] = initialRecommendation;
  }

  async getMenuConfiguration() {
    try {
      this.menuConfiguration = await this.menuConfigurationRequest(this.menuConfigurationGuid);
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('getMenuConfigurationError'), null));
      this.$emit('cancel');
    }
  }

  async getMenuInitialRecommendation() {
    this.localInitialRecommendations = cloneDeep(this.initialRecommendations);
    this.localInitialRecommendations = this.localInitialRecommendations.filter(
      (recommendation) => recommendation.activeByDefault && recommendation.menu === this.menuGuid
    );
    this.localInitialRecommendations.forEach((recommendation) => {
      recommendation.image = recommendation.image ? new File([], this.$t('previousFile')) : null;
    });
  }

  onCancel() {
    this.$emit('cancel');
    this.clearOwnData();
  }

  onConfirm() {
    // Needed to avoid rule notDuplicateServices, because selectedInitialRecommendation could be
    // filled leading to errors
    this.selectedInitialRecommendation = null;

    if (this.$refs.form.validate()) {
      this.menuConfiguration.useButtons = this.useButtons;
      this.menuConfiguration.useShoppingCart = this.useShoppingCart;
      this.availableLanguages.forEach((language) => {
        this.menuConfiguration[`recommendationText${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.recommendationText[language.alternative];
      });
      this.menuConfiguration.useProductRecommendations = this.useProductRecommendations;
      this.menuConfiguration.useInitialRecommendations = this.useInitialRecommendations;
      this.availableLanguages.forEach((language) => {
        this.menuConfiguration[`footerText${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.footerText[language.alternative];
        this.menuConfiguration[`shopText${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopText[language.alternative];
        this.menuConfiguration[`shopTextProductPopupQty${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopTextProductPopupQty[language.alternative];
        this.menuConfiguration[`shopTextProductPopupComment${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopTextProductPopupComment[language.alternative];
        this.menuConfiguration[`shopTextProductPopupSpecialTextComment${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopTextProductPopupSpecialTextComment[language.alternative];
        this.menuConfiguration[`shopTextProductPopupAddBtn${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopTextProductPopupAddBtn[language.alternative];
        this.menuConfiguration[`shopCartTextTotal${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopCartTextTotal[language.alternative];
        this.menuConfiguration[`shopCartTextOrderBtn${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopCartTextOrderBtn[language.alternative];
        this.menuConfiguration[`shopCartTextCommentBtnSave${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopCartTextCommentBtnSave[language.alternative];
        this.menuConfiguration[`shopCartTitleModal${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopCartTitleModal[language.alternative];
        this.menuConfiguration[`shopCartSuccessMessageOrder${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopCartSuccessMessageOrder[language.alternative];
        this.menuConfiguration[`shopCartErrorMessageOrder${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`] = this.shopCartErrorMessageOrder[language.alternative];
      });
      this.menuConfiguration.brandingImage = this.brandingImage;
      const recommendationsChanged = this.getRecommendationsChanged();
      this.$emit('confirm', {
        menuConfiguration: this.menuConfiguration,
        initialRecommendations: recommendationsChanged,
        deletedInitialRecommendations: this.deletedInitialRecommendations
      });
      this.clearOwnData();
    }
  }

  onEditInitialRecommendation() {
    this.$router.push({ name: 'menu-initial-recommendation' });
  }

  getRecommendationsChanged() {
    const initialRecommendationsPropsByGuid = new Map();
    this.initialRecommendations.forEach((recommendation) => initialRecommendationsPropsByGuid.set(recommendation.guid, recommendation));

    const recommendationsChanged = [];
    this.localInitialRecommendations.forEach((recommendation) => {
      if (!recommendation.guid) {
        recommendationsChanged.push(recommendation);
      } else {
        const oldRecommendation = initialRecommendationsPropsByGuid.get(recommendation.guid);
        if (this.hasChangesRecommendation(oldRecommendation, recommendation)) {
          recommendationsChanged.push(recommendation);
        }
      }
    });
    return recommendationsChanged;
  }

  hasChangesRecommendation(oldRecommendation, newRecommendation) {
    const hasChangesTitle = oldRecommendation.title !== newRecommendation.title;
    const hasChangesText = this.availableLanguages.some((language) => {
      const lang = `text${language.alternative.charAt(0).toUpperCase() + language.alternative.slice(1)}`;
      const oldRecommendationText = oldRecommendation[lang];
      const newRecommendationText = newRecommendation[lang];
      return oldRecommendationText !== newRecommendationText;
    });
    const hasChangesImages = oldRecommendation.image !== newRecommendation.image;
    const hasChangesProduct = oldRecommendation.product !== newRecommendation.product;
    const hasChangesDays = oldRecommendation.monday !== newRecommendation.monday
      || oldRecommendation.tuesday !== newRecommendation.tuesday
      || oldRecommendation.wednesday !== newRecommendation.wednesday
      || oldRecommendation.thursday !== newRecommendation.thursday
      || oldRecommendation.friday !== newRecommendation.friday
      || oldRecommendation.saturday !== newRecommendation.saturday
      || oldRecommendation.sunday !== newRecommendation.sunday;
    return hasChangesTitle || hasChangesText || hasChangesImages || hasChangesProduct || hasChangesDays;
  }

  onCreateDefaultRecommendation() {
    const defaultRecommendation = new MenuInitialRecommendation();
    defaultRecommendation.activeByDefault = true;
    defaultRecommendation.menu = this.menuGuid;
    this.localInitialRecommendations.push(defaultRecommendation);
  }

  onDeleteDefaultRecommendation(initialRecommendation) {
    const index = this.localInitialRecommendations.findIndex((recommendation) => recommendation.guid === initialRecommendation.guid);
    this.localInitialRecommendations.splice(index, 1);
    if (initialRecommendation.guid) {
      this.deletedInitialRecommendations.push(initialRecommendation);
    }
  }

  clearOwnData() {
    this.valid = false;
    this.useButtons = false;
    this.useShoppingCart = false;
    this.recommendationText = {};
    this.useProductRecommendations = false;
    this.useInitialRecommendations = false;
    this.localInitialRecommendations = [];
    this.deletedInitialRecommendations = [];
    this.selectedInitialRecommendation = null;
    this.brandingImage = null;
    this.footerText = {};
  }
}
</script>

<style>
.v-color-picker__dot {
  box-shadow: 0 0 2px;
}
</style>

<style scoped>
.border-avatar {
  border: #000 1px;
}

.position-elements {
  left: 0;
  right: auto;
  font-size: 12px;
}

.chip-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.h-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}

.no-wrap {
  text-overflow: initial;
  overflow: initial;
  white-space: nowrap;
}

.my-tabs .v-tab {
  flex: 1;
  justify-content: center;
  margin-top: 5px;
}

</style>
